<app-date-select
    *ngIf="dateFilter"
    [property]="dateFilter"
    [disabled]="false"
    (onChange)="onChange($event)"
></app-date-select>
